// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 参照方式 枚举类
 * 参照的交互方式
 */
export enum EnumRefStyle {
  /** 下拉 : 普通的下拉，显示实体的标题列 */
  DDL = 1,
  /** 表格 : 参照显示为表格，可选中一行 */
  Table = 2,
  /** 弹出窗体 : 弹出窗体进行行选择 */
  OpenWindow = 4
}

/**
 * 参照方式 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumRefStyleMD {
  private static items = [
    new EnumItemMD('DDL', 1, '下拉', '普通的下拉，显示实体的标题列'),
    new EnumItemMD('Table', 2, '表格', '参照显示为表格，可选中一行'),
    new EnumItemMD('OpenWindow', 4, '弹出窗体', '弹出窗体进行行选择')
  ];

  static getItem(enumItem: EnumRefStyle) {
    return this.items.find(item => item.name === EnumRefStyle[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
